var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8536 4.14694C14.0488 4.34221 14.0488 4.65879 13.8535 4.85405L6.85355 11.8537C6.65829 12.049 6.34172 12.049 6.14646 11.8537L2.64646 8.35406C2.45119 8.15881 2.45118 7.84222 2.64643 7.64695C2.84168 7.45168 3.15827 7.45167 3.35354 7.64692L6.49999 10.7931L13.1465 4.14693C13.3417 3.95167 13.6583 3.95168 13.8536 4.14694Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.ea8ef857.svg";
export { ForwardRef as ReactComponent };